import * as React from 'react';

import type { Stream } from 'stores/streams/StreamsStore';
import { StatusIcon, Tooltip } from 'components/common';

import useStreamDataWarehouseStatus from '../hooks/useStreamDataWarehouseStatus';

type Props = {
  stream: Stream
}

const DataWareHouseCell = ({ stream }: Props) => {
  const { data: config, isFetching } = useStreamDataWarehouseStatus(stream.id);

  if (!stream.is_editable || isFetching) {
    return null;
  }

  const isDataWareHouseEnabled = config?.enabled || false;

  return (
    <Tooltip withArrow position="right" label={`Data warehouse is ${isDataWareHouseEnabled ? 'enabled' : 'disabled'}`}>
      <StatusIcon active={isDataWareHouseEnabled} />
    </Tooltip>
  );
};

export default DataWareHouseCell;
